import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-other-documents',
  templateUrl: './other-documents.component.html',
  styleUrls: ['./other-documents.component.css']
})
export class OtherDocumentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
